export const Dislikeoptions = [
    {
      name: "HarmfullandUnsafe",
      Value: "Esto es dañino/inseguro"
    },
    {
      name: "Untrue",
      Value: "Esto no es verdadero"
    },
    {
      name: "NotHelpful",
      Value: "Esto no es útil"
    }
  ];
  